import { useAppSelector } from 'store/store-hooks';

export const useMaskOptions = () => {
  const { currencyDetail } = useAppSelector((s) => s.prefetch);

  return {
    moneyMaskOptions: {
      prefix: '',
      suffix: ` ${currencyDetail?.symbol}`,
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ',',
      allowDecimal: true,
      decimalSymbol: '.',
      decimalLimit: 2,
      integerLimit: 10,
      allowNegative: false,
      allowLeadingZeroes: false,
    },
    numericMaskOptions: {
      prefix: '',
      suffix: '',
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: '',
      allowDecimal: true,
      decimalSymbol: '',
      decimalLimit: 2,
      integerLimit: 10,
      allowNegative: false,
      allowLeadingZeroes: false,
    },
  };
};
